/*
  WALL SIZE (snippets/wall-size.liquid, 2026-10-15): a collection's size on the wall follows the gap on the slider. A
  row is n CUBEs of 18 cm and n - 1 gaps; the slider counts in cm, or in whole inches where the page measures in
  inches. A grid that changes on the page (the Individual Collection's +/-) is written into the sizes'
  data-grid-len/-wid by its own script, which then sends `cf:wall-grid`.
*/
const CUBE_CM = 18;
const CM_PER_IN = 2.54;

const sliders = () => [...document.querySelectorAll('[data-wall-spacing]')];

const render = () => {
  const slider = sliders()[0];
  let gapCm = 5;

  if (slider) {
    const value = Number(slider.value) || 0;
    gapCm = slider.dataset.unit === 'in' ? value * CM_PER_IN : value;
  }

  document.querySelectorAll('[data-wall-size]').forEach((size) => {
    const cols = Number(size.dataset.gridLen) || 0;
    const rows = Number(size.dataset.gridWid) || 0;
    if (!cols || !rows) return;

    const inUnit = (cm) => Math.round(size.dataset.unit === 'in' ? cm / CM_PER_IN : cm);
    const across = inUnit((cols * CUBE_CM) + ((cols - 1) * gapCm));
    const down = inUnit((rows * CUBE_CM) + ((rows - 1) * gapCm));
    size.textContent = `${across} × ${down} ${size.dataset.unitLabel}`;
  });

  sliders().forEach((each) => {
    const output = each.parentElement.querySelector('[data-wall-spacing-out]');
    if (output) output.textContent = `${each.value} ${each.dataset.unitLabel}`;
  });
};

document.addEventListener('input', (event) => {
  if (!event.target.matches?.('[data-wall-spacing]')) return;

  sliders().forEach((each) => {
    if (each !== event.target) each.value = event.target.value;
  });
  render();
});

document.addEventListener('cf:wall-grid', render);
render();
